
/**
 * 메시지 상태 정보
 */
export type MessagingSendMessage201AllOfStatus = {
  isRead?: boolean;
};
